<div id="validation">
    <!-- <hyperkit-typography variant="h5">Reg Add</hyperkit-typography> -->
    <hyperkit-typography variant="body1">{{ packageValidation() }}</hyperkit-typography>
</div>
<div id="atomic-red-validation">
    <hyperkit-typography variant="h5">Atomic Red Team Validation</hyperkit-typography>
    <hyperkit-typography variant="body1">N/A</hyperkit-typography>
</div>
<div id="notes">
    <hyperkit-typography variant="h5">Notes</hyperkit-typography>
    <hyperkit-typography variant="body1">N/A</hyperkit-typography>
</div>
